// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat&family=Roboto&family=Lato&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import Google Fonts */

/* Define custom variables */
:root {
    /* Colors */
    --neutral-1: #f5f5f5;
    --neutral-2: #d4d4d4;
    --neutral-3: #737373;

    --red-1: #ef4444;

    /* Standard pxs */
    --x-big: 64px;
    --big: 32px;
    --normal: 16px;
    --small: 8px;
    --x-small: 4px;

    /* Others */
}

/* Apply general styling and reset */
html {
    box-sizing: border-box;
}

*,
*::before,
*::after {
    box-sizing: inherit;
    margin: 0;
    padding: 0;
}

h1,
h2,
h3 {
    font-family: "Montserrat", sans-serif;
}

input,
button {
    font: inherit;
    padding: var(--x-small) var(--small);
    border-radius: var(--x-small);
}

body {
    font-family: 'Roboto', sans-serif;
    display: grid;
    grid-template-rows: 10vh 85vh 5vh;
}

header,
main,
footer {
    padding: var(--small);
}

body header {
    display: flex;
    align-items: center;
    justify-content: space-around;
}

header .notification {
    padding: var(--small) var(--normal);
    background-color: var(--neutral-1);
    min-width: 30%;
}

main {
    display: grid;
    grid-template-rows: 90% repeat(2, 5%);
}

main .gameboards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: var(--big);
    user-select: none;
}

.gameboards>div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--x-small);
}

.gameboards .gameboard {
    display: grid;
    grid-template-columns: repeat(11, 40px);
    grid-template-rows: repeat(11, 40px);
    margin-top: var(--small);
    border: 1px solid var(--neutral-2);
    border-radius: var(--x-small);
}

.computer {
    position: relative;
}

.computer .gameboard {
    filter: blur(var(--x-small));
    pointer-events: none;
}

.start-button {
    position: absolute;
    padding: var(--small) var(--normal);
    cursor: pointer;
    border: 2px solid var(--neutral-3);
    background-color: var(--neutral-1);
    will-change: contents;
    transition: transform 0.3s;
}

.start-button:hover {
    transform: scale(1.05);
}

.start-button:active {
    transform: scale(0.95);
}

.gameboard .cell {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--neutral-2);
}

.cell:hover {
    border: 2px solid var(--neutral-3);
}

.cell.label {
    background-color: var(--neutral-2);
    border: none;
    font-weight: bold;
}

.cell.player-ship {
    background-color: var(--neutral-3);
    border: none;
}

.cell.attacked {
    pointer-events: none;
    border: none;
}

.cell.hit {
    background-color: var(--red-1);
}

.cell.miss {
    background-color: var(--neutral-1);
}

main .randomize {
    display: flex;
    align-items: center;
    gap: var(--x-small);
    background-color: var(--neutral-2);
    max-width: fit-content;
    padding: 2px var(--small);
    border-radius: var(--x-small);
    transition: transform 0.3s;
    cursor: pointer;
    will-change: contents;
}

.randomize:hover {
    transform: translateX(var(--x-small));
}

.randomize:active {
    transform: scale(0.95);
}

.randomize .mdi {
    font-size: 20px;
}

main .settings {
    margin-top: var(--normal);
}

main .settings,
.checkboxes,
.checkboxes div {
    display: flex;
    align-items: center;
    gap: var(--small);
}

.checkboxes div {
    gap: var(--x-small);
}

footer {
    font-style: italic;
    display: flex;
    align-items: center;
    justify-content: center;
    color: black;
}

footer .author {
    color: inherit;
}

footer .author:hover {
    font-weight: 900;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAGxB,4BAA4B;AAC5B;IACI,WAAW;IACX,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;;IAEpB,gBAAgB;;IAEhB,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,cAAc;IACd,YAAY;IACZ,cAAc;;IAEd,WAAW;AACf;;AAEA,oCAAoC;AACpC;IACI,sBAAsB;AAC1B;;AAEA;;;IAGI,mBAAmB;IACnB,SAAS;IACT,UAAU;AACd;;AAEA;;;IAGI,qCAAqC;AACzC;;AAEA;;IAEI,aAAa;IACb,oCAAoC;IACpC,6BAA6B;AACjC;;AAEA;IACI,iCAAiC;IACjC,aAAa;IACb,iCAAiC;AACrC;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,mCAAmC;IACnC,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uCAAuC;IACvC,oCAAoC;IACpC,wBAAwB;IACxB,kCAAkC;IAClC,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,mCAAmC;IACnC,eAAe;IACf,kCAAkC;IAClC,kCAAkC;IAClC,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kCAAkC;IAClC,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;IAC7B,0BAA0B;IAC1B,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["/* Import Google Fonts */\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat&family=Roboto&family=Lato&display=swap\");\n\n/* Define custom variables */\n:root {\n    /* Colors */\n    --neutral-1: #f5f5f5;\n    --neutral-2: #d4d4d4;\n    --neutral-3: #737373;\n\n    --red-1: #ef4444;\n\n    /* Standard pxs */\n    --x-big: 64px;\n    --big: 32px;\n    --normal: 16px;\n    --small: 8px;\n    --x-small: 4px;\n\n    /* Others */\n}\n\n/* Apply general styling and reset */\nhtml {\n    box-sizing: border-box;\n}\n\n*,\n*::before,\n*::after {\n    box-sizing: inherit;\n    margin: 0;\n    padding: 0;\n}\n\nh1,\nh2,\nh3 {\n    font-family: \"Montserrat\", sans-serif;\n}\n\ninput,\nbutton {\n    font: inherit;\n    padding: var(--x-small) var(--small);\n    border-radius: var(--x-small);\n}\n\nbody {\n    font-family: 'Roboto', sans-serif;\n    display: grid;\n    grid-template-rows: 10vh 85vh 5vh;\n}\n\nheader,\nmain,\nfooter {\n    padding: var(--small);\n}\n\nbody header {\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n}\n\nheader .notification {\n    padding: var(--small) var(--normal);\n    background-color: var(--neutral-1);\n    min-width: 30%;\n}\n\nmain {\n    display: grid;\n    grid-template-rows: 90% repeat(2, 5%);\n}\n\nmain .gameboards {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: var(--big);\n    user-select: none;\n}\n\n.gameboards>div {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: var(--x-small);\n}\n\n.gameboards .gameboard {\n    display: grid;\n    grid-template-columns: repeat(11, 40px);\n    grid-template-rows: repeat(11, 40px);\n    margin-top: var(--small);\n    border: 1px solid var(--neutral-2);\n    border-radius: var(--x-small);\n}\n\n.computer {\n    position: relative;\n}\n\n.computer .gameboard {\n    filter: blur(var(--x-small));\n    pointer-events: none;\n}\n\n.start-button {\n    position: absolute;\n    padding: var(--small) var(--normal);\n    cursor: pointer;\n    border: 2px solid var(--neutral-3);\n    background-color: var(--neutral-1);\n    will-change: contents;\n    transition: transform 0.3s;\n}\n\n.start-button:hover {\n    transform: scale(1.05);\n}\n\n.start-button:active {\n    transform: scale(0.95);\n}\n\n.gameboard .cell {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid var(--neutral-2);\n}\n\n.cell:hover {\n    border: 2px solid var(--neutral-3);\n}\n\n.cell.label {\n    background-color: var(--neutral-2);\n    border: none;\n    font-weight: bold;\n}\n\n.cell.player-ship {\n    background-color: var(--neutral-3);\n    border: none;\n}\n\n.cell.attacked {\n    pointer-events: none;\n    border: none;\n}\n\n.cell.hit {\n    background-color: var(--red-1);\n}\n\n.cell.miss {\n    background-color: var(--neutral-1);\n}\n\nmain .randomize {\n    display: flex;\n    align-items: center;\n    gap: var(--x-small);\n    background-color: var(--neutral-2);\n    max-width: fit-content;\n    padding: 2px var(--small);\n    border-radius: var(--x-small);\n    transition: transform 0.3s;\n    cursor: pointer;\n    will-change: contents;\n}\n\n.randomize:hover {\n    transform: translateX(var(--x-small));\n}\n\n.randomize:active {\n    transform: scale(0.95);\n}\n\n.randomize .mdi {\n    font-size: 20px;\n}\n\nmain .settings {\n    margin-top: var(--normal);\n}\n\nmain .settings,\n.checkboxes,\n.checkboxes div {\n    display: flex;\n    align-items: center;\n    gap: var(--small);\n}\n\n.checkboxes div {\n    gap: var(--x-small);\n}\n\nfooter {\n    font-style: italic;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: black;\n}\n\nfooter .author {\n    color: inherit;\n}\n\nfooter .author:hover {\n    font-weight: 900;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
